import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
    DISABLE_OR_ENABLE_BUTTON,
    FEEDBACKS_CUSTOMER_STATUS,
} from '../../../constants';
import {
    feedbackState,
    pageNumber,
    pageNumberVisibility,
    presentationVM,
    promoFeedback,
    updateFeedbackState,
    vmState,
} from '../../../state/recoilState';
import {
    BasicScreenProps,
    Feedback,
    PromoFeedback,
    VendingMachine,
    updateFeedback,
} from '../../../types';
import { updateFeedbacks } from '../../../utils/general';
import ContentBox from '../../common/ContentBox';
import ScreenTitle from '../../common/ScreenTitle';
import ScreenWrapper from '../../common/ScreenWrapper';
import { CustomTextField } from './components/CustomTextField';
import {
    FeedbacksButton,
    FeedbacksButtonBox,
} from './components/FeedbacksStyles';
import { Box, TextField } from '@mui/material';

interface ContactPage extends BasicScreenProps {
    onCancel?: () => void;
}

interface FieldsDataState {
    NameField: string;
    PhoneNumber: string;
    Company: string;
    Email: string
}

const ContactPage = (props: ContactPage) => {
    const [updatedFeedback, setUpdateFeedback] =
        useRecoilState<updateFeedback>(updateFeedbackState);
    //const vm = useRecoilValue<VendingMachine>(vmState);
    const [vm, setVm] = useRecoilState(presentationVM);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [notes, setNotes] = useState<FieldsDataState>({
        NameField: '',
        PhoneNumber: '',
        Company: '',
        Email: ''
    });
    const [promoFeedbacks, setPromoFeedbacks] = useRecoilState<PromoFeedback>(promoFeedback);
    const isNextButtonEnabled =
        notes.NameField.trim() !== '' && notes.PhoneNumber.trim() !== '';
    const nextButtonStyles = isNextButtonEnabled
        ? DISABLE_OR_ENABLE_BUTTON[0]
        : DISABLE_OR_ENABLE_BUTTON[1];
    const newFeedback = {
        ...updatedFeedback,
        customer_status: FEEDBACKS_CUSTOMER_STATUS.AFTER_CONTACT_PAGE,
        customer_phone_number: notes.PhoneNumber ? 'Phone:' + notes.PhoneNumber + ';' + ' Email:' + notes.Email : null,
        customer_name: notes.NameField ? 'Name:' + notes.NameField + ';' + ' Company:' + notes.Company : null,
    };

    const handlePhoneInputChange = (event: {
        target: { id: string; value: string };
    }) => {
        const { id, value } = event.target;
        const sanitizedValue = value.replace(/[^0-9]/g, '')
        setNotes({
            NameField: id === 'NameField' ? sanitizedValue : notes.NameField,
            PhoneNumber: id === 'PhoneNumber' ? sanitizedValue : notes.PhoneNumber,
            Company: id === 'Company' ? sanitizedValue : notes.Company,
            Email: id === 'Email' ? sanitizedValue : notes.Email
        });
    };

    const handleNotesChange = (event: {
        target: { id: string; value: string };
    }) => {
        const { id, value } = event.target;
        const sanitizedValue = value.replace(/[\/\\|^*\[\]{}?%$!#&-,:;"<>]/gi, '');
        setNotes({
            NameField: id === 'NameField' ? sanitizedValue : notes.NameField,
            PhoneNumber: id === 'PhoneNumber' ? sanitizedValue : notes.PhoneNumber,
            Company: id === 'Company' ? sanitizedValue : notes.Company,
            Email: id === 'Email' ? sanitizedValue : notes.Email
        });
    };

    const sendCredit = (vm: number | string, body: any): void => {
        fetch(`/api/connect?vm=${vm}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        }).catch((error) => {
            console.log('update error', error);
        });
    };
    const creditBody = {
        broker_id: vm.broker_id,
        imei: vm.imei,
        max_credit_app: vm.max_credit_app,
        voc_id: vm.voc_id,
        posId: vm.posId,
        companyId: vm.companyId
    }

    const onNextPage = () => {
        setUpdateFeedback(newFeedback);
        updateFeedbacks(promoFeedbacks.id, newFeedback);
        if(vm.status_connected == 1){
            sendCredit(vm.id, creditBody)
            navigate(`/completepage`);
        }else{
            navigate(`/notconnected`);

        }
        // setNumberVisibility(false);
    };
    const onCancelClick = () => {
        // setNumberVisibility(false);
        navigate(`/checkboxpage`, { replace: true });
    };
   
    return (
        <ScreenWrapper>
            <Box
                sx={{
                    fontSize: 'min(5.2vw, 40px)',
                    fontWeight: '400',
                    color: '#1b3f92',
                    paddingBottom: '0.2rem',
                    textAlign: 'center',
                }}
            >
                {t(
                    'If appropriate, we are glad to re-connect with you later, please share your contacts'
                )}
            </Box>
            <ContentBox>
                <CustomTextField
                    id="NameField"
                    label={t('Name*')}
                    onChange={handleNotesChange}
                    rows={1}
                />
                <CustomTextField
                    id="Company"
                    label={t('Company')}
                    onChange={handleNotesChange}
                    rows={1}
                />
                <CustomTextField
                    id="PhoneNumber"
                    label={t('Phone Number*')}
                    onChange={handlePhoneInputChange}
                    //rows={1.5}
                    type="number"
                    multilineParam={false}
                />
                <CustomTextField
                    id="Email"
                    label={t('Email')}
                    onChange={handleNotesChange}
                    rows={1}
                    typeField='number'
                />

                <FeedbacksButtonBox>
                    <FeedbacksButton onClick={onCancelClick}>
                        {t('Back')}
                    </FeedbacksButton>
                    <FeedbacksButton
                        onClick={onNextPage}
                        disabled={!isNextButtonEnabled}
                        style={nextButtonStyles}
                    >
                        {t('Present')}
                    </FeedbacksButton>
                </FeedbacksButtonBox>
            </ContentBox>
        </ScreenWrapper>
    );
};

export default ContactPage;
